import { type App, hasInjectionContext, type InjectionKey, inject } from 'vue'

const key: InjectionKey<URL | Location> = Symbol('location')

export const createLocation = (url?: string | URL) => ({
  install: (app: App) => {
    const value = url ? new URL(url) : globalThis.location
    if (value) {
      app.provide(key, value)
    }
  }
})

export const useLocation = () => (hasInjectionContext() && inject(key, undefined)) || globalThis.location || undefined
